document.querySelectorAll('[data-frey-ranch-sticky-bar]').forEach((bar) => {
  const section = bar.closest('.frey-ranch');
  const hero = section && section.querySelector('.frey-ranch__hero');
  const buySection = section && section.querySelector('.frey-ranch__buy');
  const footer = document.querySelector('.footer');
  if (!hero || !buySection) return;

  let heroVisible = true;
  let buyVisible = false;
  let footerVisible = false;

  function updateVisibility() {
    bar.classList.toggle('frey-ranch__sticky-bar--visible', !heroVisible && !buyVisible && !footerVisible);
  }

  new IntersectionObserver((entries) => {
    heroVisible = entries[0].isIntersecting;
    updateVisibility();
  }).observe(hero);

  new IntersectionObserver((entries) => {
    buyVisible = entries[0].isIntersecting;
    updateVisibility();
  }).observe(buySection);

  if (footer) {
    new IntersectionObserver((entries) => {
      footerVisible = entries[0].isIntersecting;
      updateVisibility();
    }).observe(footer);
  }
});
